<script setup lang="ts">
  import CheckboxField from '@/components/admin/form/CheckboxField.vue'
  import { defineProps, computed } from 'vue'
  import { useQuestionnaireEditorStore } from '@/store/admin/questionnaire/questionnaireEditor'
  import type { SuperUserOrganisation as Organisation } from '@/types/generated'
  import CustomerDisplay from '@/components/admin/CustomerDisplay.vue'

  const questionnaireEditorStore = useQuestionnaireEditorStore()
  const organisation = computed<Organisation>(() =>
    questionnaireEditorStore.organisations.find((o) => o.uuid === props.uuid)
  )
  const questionnaire = computed(() => questionnaireEditorStore.questionnaire)

  const props = defineProps({
    uuid: {
      type: String,
      required: true
    },
    search: {
      type: String,
      required: false,
      default: ''
    }
  })

  const isEnabled = computed<boolean>(() => {
    return questionnaire.value?.enabled_custom_orgs.includes(organisation.value.uuid) ?? false
  })

  const toggleEnabled = () => {
    if (!isEnabled.value) {
      questionnaireEditorStore.addCustomOrganisation(organisation.value.uuid)
    } else {
      questionnaireEditorStore.removeCustomOrganisation(organisation.value.uuid)
    }
  }

  const canDisplay = computed(() => {
    return organisation.value?.name.toLowerCase().includes(props.search.toLowerCase())
  })
</script>
<template>
  <div
    v-if="canDisplay"
    class="flex items-center justify-start gap-x-4 border-b border-gray-200 p-2 dark:border-gray-700"
  >
    <input
      id="optional"
      class="ms-2 h-5 w-5 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
      type="checkbox"
      name="optional"
      :checked="isEnabled"
      @change="toggleEnabled"
    />

    <CustomerDisplay :org="organisation" />
  </div>
</template>
